<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>RECHARGE HISTORY</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Recharge History</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="row card">
          <div class="col-md-12 card-body pt-0 pb-2">
            <div
              class="custom-list history-list"
              v-for="(item, index) in list.data"
              :key="item.id"
            >
              <ul>
                <li>
                  <strong> {{ "Transaction ID" }} </strong>

                  <!-- {{  '#'+ item.paymentId }} -->
                  {{
                    !_.isEmpty(item.mer_transactionid)
                      ? item.mer_transactionid
                      : ""
                  }}
                </li>

                <li>
                  <strong> {{ "Payment Time" }} </strong>
                  {{ item.payment_time }}
                </li>

                <li>
                  <strong> {{ "Amount" }} </strong>
                  <span class="amount">
                    {{ item.total_amount + " TK" }}
                  </span>
                </li>

                <li>
                  <strong> {{ "Status" }} </strong>
                  <span class="badge" :class="item.class">{{
                    item.payment_status
                  }}</span>
                </li>
              </ul>
            </div>

            <!-- <div class="employee-list">
                    <swipe-list
                        ref="list"
                        class="card"
                        :items="list.data"
                        item-key="mer_transactionid"
                        @swipeout:click="itemClick"
                    >

                      <template v-slot="{ item, index, revealLeft, revealRight, close }">

                          <li style="list-style-type: none;">
                          <hr/>
                          <div class="card-content d-flex align-items-center">


                              <div>
                                  <p>
                                  <span><b> {{'Transaction ID:'}} </b></span>
                                  <span>{{ item.mer_transactionid }}</span>
                                  </p>
                                  <p>
                                    <span><b> {{'Payment Time:'}} </b></span>
                                    <span>{{ item.payment_time }}</span>
                                  </p>

                                  <p>
                                    <span><b> {{'Amount:'}} </b></span>
                                    <span>{{ item.total_amount + ' TK'}}</span>
                                  </p>
                                  <p>
                                    <span><b> {{'Status:'}} </b></span>
                                    <span :class="item.class">{{ item.payment_status }}</span>
                                  </p>
                              </div>
                              <div><i class="fas fa-chevron-left"></i></div>
                          </div>
                          </li>

                      </template>

                        <template v-slot:left="{ item, close }">

                        </template>

                        <template v-slot:right="{ item }">

                        </template>

                        <template v-slot:empty>
                            <div>
                                list is empty ( filtered or just empty )
                            </div>
                        </template>

                    </swipe-list>

              </div> -->

            <div class="overlay" v-if="list.is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>

            <div
              class="p-4"
              v-if="_.isEmpty(list.data) && list.is_loading == false"
            >
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="getRechargeList()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<style scoped>
span.amount {
  font-weight: 800;
  font-size: 14px;
  color: black;
}
div.card-content {
  margin-left: 2%;
}

.success {
  background: #caffd6;
  color: #119a30;
  /* border-radius: 100px; */
  /* padding: 4px 15px 3px; */
  border-radius: 100px;
  text-align: center;
  padding: 4px 15px 3px;
  display: inline-block;
  font-size: 13px;
}
.in-progress {
  background: #ffe9dd;
  /* color: #119A30; */
  color: #e31e0af5;
  border-radius: 100px;
  text-align: center;
  padding: 4px 15px 3px;
  display: inline-block;
  font-size: 13px;
}
</style>

<script>
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "RechargeHistory",
  metaInfo: {
    title: "Recharge History | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
    SwipeOut,
    SwipeList,
  },

  data: () => ({
    list: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
      data: [],
    },

    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
  }),
  // method is called after page load
  mounted: function () {
    if (this.isMobile()) {
      var openOrClose = window.$(document).find(".sidebar-mini");
      if ($(openOrClose).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }
    }

    // this.api_url = '/ticketList';

    this.getRechargeList();
    // this.getOrganization();

    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.getRechargeList();
    });
  },

  methods: {
    revealFirstRight() {
      this.$refs.list.revealRight(0);
    },
    revealFirstLeft() {
      this.$refs.list.revealLeft(0);
    },
    closeFirst() {
      this.$refs.list.closeActions(0);
    },
    closeAll() {
      this.$refs.list.closeActions();
    },
    remove(item) {
      this.list.data = this.list.data.filter((i) => i !== item);
      console.log("remove");
    },
    itemClick(e) {
      console.log(e, "item click");
    },
    fbClick(e) {
      console.log(e, "First Button Click");
    },
    sbClick(e) {
      console.log(e, "Second Button Click");
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getRechargeList() {
      this.list.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      this.list.data = [
        // {
        //   subject: "#92762990 Get A Call Back", lastUpdate: '12/02/2022', status: 'Open'
        // },
      ];

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        query.cuid = subscriber.username;
        axios({
          method: "get",
          url: "/get-recharge-history",
          params: query,
          headers: { "Content-Type": "application/json" },
        })
          .then((response) => {
            //console.log("Res::", response)
            this.list = response.data;
            this.list.data =
              this.list.data.length > 0
                ? this.list.data.map((o) => {
                    o.payment_time = moment(o.payment_time).format(
                      "DD/MM/YYYY"
                    );
                    o.class =
                      o.payment_status == "SUCCESS" ? "success" : "in-progress";
                    return o;
                  })
                : [];
            this.list.is_loading = false;
          })
          .catch((error) => {
            this.list.is_loading = false;
          });
      }
    },

    apiUsage(query = null) {},

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getTicketList();
    },
  },
};
</script>
